// Module
var code = "<h2 class=\"heading--isInteriorPageSubHeading\">Stay Up to Date with All Things Student Loans</h2> <p>We provide resources so you can stay up to date and in the know about the world of student loans.</p> ";
// Exports
export default code;